const accordionToOpen = {
  health: 2,
  pension: 2,
  allAround: 3,
  workingInSpace: 10,
  food: 1,
}

export default accordionToOpen
